<div class="dashboard">
  <div *ngIf="hasNoMap"
       [class.sidebar-open]="isSideBarOpen"
       class="no-map-container pt-3 d-flex justify-content-center align-items-center">
    <h4 class="text-center d-flex justify-content-center align-items-center">
      {{ 'DASHBOARD.PLEASE_USE' | translate }}
      <button (click)="selectMap()" mat-icon-button>
        <span class="icon-smap-object-smap"></span>
      </button>
      {{ 'DASHBOARD.NO_MAP_CREATE_OR_OPEN' | translate }}
    </h4>
  </div>
  <div *ngIf="hasNodesNoNodes && !hasNoMap"
       [class.sidebar-open]="isSideBarOpen"
       class="no-map-container pt-3 d-flex justify-content-center align-items-center">
    <h4 class="text-center d-flex justify-content-center align-items-center">
      {{ 'DASHBOARD.PLEASE_USE' | translate }}
      <button (click)="createNodeFromNoNodeMessage()" mat-icon-button>
        <span class="material-symbols-rounded">add</span>
      </button>
      {{ 'DASHBOARD.NO_NODES_CREATE' | translate }}
    </h4>
  </div>
  <maporium-tour-step-template #tourStepTemplateRef></maporium-tour-step-template>
  <tour-step-template [stepTemplate]="tourStepTemplateRef.customTemplate">
  </tour-step-template>
  <!-- Welcome anchor lives outside the drawer so position:fixed is viewport-
       relative (mat-drawer-content uses a transform that would otherwise scope
       fixed positioning). Vertical offset centers bubble 1 on the window, not
       just on the canvas (MAP-1245 AC 5.a.ii). -->
  <div [style.height]="0"
       [style.left]="'calc(50% - 200px)'"
       [style.position]="'fixed'"
       [style.top]="'calc(50vh - 200px)'"
       id="welcome-tour-anchor"
       tourAnchor="welcome"></div>
  <mat-drawer-container [hasBackdrop]="false" autosize class="example-container" [class.dark-loading-bg]="!isCanvasLoaded && !hasNoMap && isMapDarkMode()">
    <mat-drawer #drawer (resizeEnd)="onResizeEnd($event)"
                [autoFocus]="false"
                [enableGhostResize]="true"
                [position]="'end'"
                [style.width.px]="appliedSidebarWidth"
                [validateResize]="validateResize()"
                class="drawer"
                mode="over"
                mwlResizable>
      <div *ngIf="sidebarResizable" [resizeEdges]="{left: true}" class="resize-handle-left" mwlResizeHandle></div>
      <div class="drawer-container">
        @if (focusedLink || focusedNode || focusedOverlayElement) {
          <maporium-sidebar-form [focusedNode]="focusedNode!"
                                 [focusedLink]="focusedLink!"
                                 [readonly]="(currentMap?.isReadonly || this.isReadOnly || readModeAppState) && !hasMapPermission('edit')"
                                 (updateNode)="callNodeUpdate($event)"
                                 (updateMultiple)="callUpdateMultiple($event)"
                                 (resetMultiple)="multiReset($event)"
                                 (stateReset)="resetState($event)"
                                 (updateLink)="callLinkUpdate($event)"></maporium-sidebar-form>
        }

        @if (!focusedLink && !focusedNode && !focusedOverlayElement) {
          <maporium-map-info-section (mapMetaChanged)="updateSelectedMapMetadata($event)"
                                     [hasNoMap]="hasNoMap"
                                     [isLinkingInProgress]="isUnlinking"
                                     [readonly]="(currentMap?.isReadonly || this.isReadOnly) && !hasMapPermission('edit')">
          </maporium-map-info-section>
        }
      </div>
    </mat-drawer>
    <mat-drawer-content>
      @if (!isCanvasLoaded && !hasNoMap) {
        <app-smap-loading-animation [size]="192"
                               [dark]="isMapDarkMode()"
                               [style.position]="'absolute'"
                               [style.left]="'calc((100vw - var(--sidebar-width, 0px)) / 2)'"
                               [style.top]="'calc(50px + (100dvh - 50px) / 2)'"
                               [style.transform]="'translate(-50%, -50%)'"
                               [style.z-index]="'10'"></app-smap-loading-animation>
      }
      <div [style.left]="'var(--tour-anchor-left, 0px)'"
           [style.height]="'var(--tour-anchor-height, 20px)'"
           [style.width]="'var(--tour-anchor-width, 20px)'"
           style="height: 20px; width: 20px"
           [style.position]="'absolute'"
           [style.top]="'var(--tour-anchor-top, 0px)'"
           class="mt-3"
           id="node-tour-anchor"
           tourAnchor="node-anchor"></div>
      <div class="canvas-anchor-area"
           tourAnchor="canvas-anchor"
           [style.left]="'0'"
           [style.height]="'calc(100dvh - 50px)'"
           [style.width]="'calc(100vw - var(--sidebar-width, 0px))'"
           [style.position]="'absolute'"
           [style.top]="'50px'"></div>
      <block-ui name="UI">
        <div #cytoscapeContainer
             [ngClass]="{'no-opacity': !isCanvasLoaded}"
             appSmapStyles
             class="map-container" id="canvas"></div>
      </block-ui>
      @if (commentDraftActive()) {
        <div class="comment-draft-lock"
             data-testid="comment-draft-lock"
             (mousedown)="nudgeCommentDraft($event)"
             (touchstart)="nudgeCommentDraft($event)"
             (wheel)="nudgeCommentDraft($event)"
             (contextmenu)="nudgeCommentDraft($event)"></div>
      }


    </mat-drawer-content>

  </mat-drawer-container>

</div>
<app-tours-panel></app-tours-panel>
<maporium-scene-panel></maporium-scene-panel>
<maporium-legend-panel></maporium-legend-panel>
